export default "__VITE_ASSET__095defa2__"